/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { Industry } from './platformapi.schemas';

import getIndustriesMutator from '../custom-axios-instance';

/**
 * Retrieves a list of industries
 * @summary Get Industries
 */
export const getIndustries = (signal?: AbortSignal) => {
  return getIndustriesMutator<Industry[]>({
    url: `${import.meta.env['VITE_API_HOST']}/industries/industries`,
    method: 'GET',
    signal,
  });
};

export const getGetIndustriesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/industries/industries`] as const;
};

export const getGetIndustriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getIndustries>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndustries>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIndustriesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIndustries>>> = ({ signal }) =>
    getIndustries(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIndustries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIndustriesQueryResult = NonNullable<Awaited<ReturnType<typeof getIndustries>>>;
export type GetIndustriesQueryError = void;

export function useGetIndustries<TData = Awaited<ReturnType<typeof getIndustries>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndustries>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIndustries>>,
          TError,
          Awaited<ReturnType<typeof getIndustries>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIndustries<TData = Awaited<ReturnType<typeof getIndustries>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndustries>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIndustries>>,
          TError,
          Awaited<ReturnType<typeof getIndustries>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIndustries<TData = Awaited<ReturnType<typeof getIndustries>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndustries>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Industries
 */

export function useGetIndustries<TData = Awaited<ReturnType<typeof getIndustries>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIndustries>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIndustriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
